import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "tap_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (product, { quantity = 1, color = "", variant = "", unitPrice }) => {
    setItems((prev) => {
      const idx = prev.findIndex(
        (i) => i.product_id === product.id && i.color === color && i.variant === variant
      );
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], quantity: next[idx].quantity + quantity };
        return next;
      }
      return [...prev, {
        product_id: product.id, name: product.name, image: (product.images || [])[0] || "",
        unit_price: unitPrice, quantity, color, variant,
      }];
    });
  };

  const updateQty = (index, quantity) => {
    setItems((prev) => prev.map((i, idx) => (idx === index ? { ...i, quantity: Math.max(1, quantity) } : i)));
  };

  const removeItem = (index) => setItems((prev) => prev.filter((_, idx) => idx !== index));
  const clear = () => setItems([]);

  const total = items.reduce((s, i) => s + i.unit_price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clear, total, count }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
